var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive === true &&
    _vm.typeaheadList !== undefined &&
    _vm.typeaheadList.length > 0
    ? _c("div", { ref: "typeahead", staticClass: "typeahead-custom" }, [
        _c(
          "div",
          { staticClass: "typeahead-inner py-2 px-4" },
          [
            _vm.title !== ""
              ? _c(
                  "div",
                  {
                    staticClass:
                      "typeahead-title mb-3 d-flex justify-content-between",
                  },
                  [
                    _vm._v(_vm._s(_vm.title)),
                    _vm.isMobile
                      ? _c("b-icon", {
                          staticClass: "ml-1",
                          attrs: { icon: "x", "font-scale": "1.5" },
                          on: {
                            click: function ($event) {
                              return _vm.away()
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "table",
              { staticClass: "w-100" },
              [
                _vm.typeaheadType === 1
                  ? _vm._l(
                      _vm.typeaheadList.slice(0, _vm.sliceNumber),
                      function (item, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            staticClass: "clickable",
                            on: {
                              click: function ($event) {
                                return _vm.emitClickedItem(item)
                              },
                            },
                          },
                          [
                            _c("td", { staticClass: "typeahead-icon" }, [
                              _c(
                                "strong",
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "arrow-up-left",
                                      variant: "primary",
                                      "font-scale": "1.2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._l(
                              _vm.splitString(item.displayTextModified),
                              function (text, index) {
                                return _c("td", {
                                  key: index,
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.splitString(item.displayTextModified)[
                                        index
                                      ]
                                    ),
                                  },
                                })
                              }
                            ),
                            _c("td", { staticClass: "w-100" }),
                          ],
                          2
                        )
                      }
                    )
                  : _vm.typeaheadType === 2
                  ? _vm._l(_vm.typeaheadList, function (item, index) {
                      return _c(
                        "tr",
                        { key: index, staticClass: "clickable" },
                        [
                          _c(
                            "td",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center mt-1",
                              staticStyle: {
                                "white-space": "normal !important",
                              },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(item))]),
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn rounded ml-2",
                                  attrs: { variant: "outline-primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.emitClickedItem(item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.buttonText))]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    })
                  : _vm._e(),
              ],
              2
            ),
            _vm._t("default"),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }